import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { CurrentUserGateway } from './current-user-gateway'
import { CurrentUser } from '../models/current-user'

@Injectable()
export class NetworkCurrentUserGateway extends CurrentUserGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getCurrentUser(): Observable<CurrentUser> {
        return this.http.get<CurrentUser>('../api/currentuser')
    }

    getCurrentUserByName(): Observable<CurrentUser> {
        return this.http.get<CurrentUser>('../api/currentuserByName')
    }

    isLicenseExpiring(currentUser: CurrentUser): Observable<any> {
        return this.http.post<any>('../api/isLicenseExpiring', JSON.stringify(currentUser))

    }

}
